
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.45 38.78a6.5 6.5 0 00-13 0M33.27 26.06l.05-6H14.46M33.32 19.93a9.43 9.43 0 00-18.86 0","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M9.74 25.93h28.42V38.6H9.74zM3.54 7.93V5.72a4.5 4.5 0 019 0v2.21"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M8.75 38.6H1.84V8.09h12.4v18.45M1.92 13.88h12"}})])
          )
        }
      }
    